const SDK_VERSION = '7.48.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
